import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6ca932ae&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=6ca932ae&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca932ae",
  null
  
)

export default component.exports